import { TicketDetailReader } from './TicketDetailReader';

export class LockedTicketReader extends TicketDetailReader {
  constructor(ticket, lock) {
    super(ticket);

    this.ticketLock = lock;
  }

  get status() {
    return 'locked';
  }
}
